import UniversalConsentItemCreateEdit from './universal_consent_item_create_edit';
import blankRAViews from '../../components/BlankRAViews';

export default {
  ...blankRAViews,
  create: UniversalConsentItemCreateEdit,
  edit: UniversalConsentItemCreateEdit,
};
